const TABS = ['Mine', 'Hero', 'Trail', 'Crew', 'Shop'] as const;

/** Mount the bottom nav shell (clears the home bar via --sab). */
export function mountBottomNav(root: HTMLElement): void {
  root.innerHTML = TABS.map(
    (label, i) => `
      <button type="button" class="bottom-nav__tab${i === 0 ? ' is-active' : ''}" data-tab="${label.toLowerCase()}" data-testid="nav-${label.toLowerCase()}">
        <span class="bottom-nav__icon" aria-hidden="true"></span>
        <span>${label}</span>
      </button>
    `,
  ).join('');

  root.addEventListener('click', (ev) => {
    const btn = (ev.target as HTMLElement).closest<HTMLButtonElement>('.bottom-nav__tab');
    if (!btn) return;
    root.querySelectorAll('.bottom-nav__tab').forEach((el) => el.classList.remove('is-active'));
    btn.classList.add('is-active');
  });
}
